import { render, staticRenderFns } from "./ShipFrom.vue?vue&type=template&id=06913886&scoped=true"
import script from "./ShipFrom.vue?vue&type=script&lang=ts"
export * from "./ShipFrom.vue?vue&type=script&lang=ts"
import style0 from "./ShipFrom.vue?vue&type=style&index=0&id=06913886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06913886",
  null
  
)

export default component.exports